import { OrganizationsSliceActions } from "./workspace.store";

export const {
  setOrganization,
  patchOrganization,
  setCredits,
  patchCredits
} = OrganizationsSliceActions;
